// ============================================
// BEFORE / AFTER COMPARE SLIDERS
// ============================================
document.addEventListener("DOMContentLoaded", function() {
  const sliders = document.querySelectorAll("[data-compare]");

  sliders.forEach(slider => {
    const beforeWrap = slider.querySelector(".before_after__before-wrap");
    const handle = slider.querySelector("[data-compare-handle]");
    if (!beforeWrap || !handle) return;

    let isDragging = false;
    let touchStartX = 0;
    let touchStartY = 0;
    let dragDirection = null; // 'horizontal' | 'vertical' | null

    // Bereken percentage op basis van muis/touch positie
    function updatePosition(clientX) {
      const rect = slider.getBoundingClientRect();
      let x = clientX - rect.left;
      
      x = Math.max(0, Math.min(x, rect.width));
      const percent = (x / rect.width) * 100;

      beforeWrap.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      handle.style.left = `${percent}%`;
    }

    // ----- Mouse handlers (desktop) -----
    function onMouseDown(event) {
      isDragging = true;
      slider.style.cursor = "grabbing";
      updatePosition(event.clientX);
      event.preventDefault();
    }

    function onMouseMove(event) {
      if (!isDragging) return;
      updatePosition(event.clientX);
    }

    function onMouseUp() {
      isDragging = false;
      slider.style.cursor = "ew-resize";
    }

    // ----- Touch handlers (mobiel) -----
    function onTouchStart(event) {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      dragDirection = null;
      isDragging = true;
      // GEEN preventDefault hier — we weten nog niet of het horizontaal of verticaal is
    }

    function onTouchMove(event) {
      if (!isDragging) return;

      const currentX = event.touches[0].clientX;
      const currentY = event.touches[0].clientY;
      const deltaX = Math.abs(currentX - touchStartX);
      const deltaY = Math.abs(currentY - touchStartY);

      // Bepaal de intentie van de gebruiker op basis van eerste beweging
      if (dragDirection === null) {
        if (deltaX > 10 || deltaY > 10) {
          dragDirection = deltaX > deltaY ? 'horizontal' : 'vertical';
        }
      }

      // Alleen ingrijpen als gebruiker horizontaal veegt
      if (dragDirection === 'horizontal') {
        updatePosition(currentX);
        event.preventDefault();
      }
      // Bij verticale beweging: laat de pagina normaal scrollen
    }

    function onTouchEnd() {
      isDragging = false;
      dragDirection = null;
    }

    // ----- Event listeners -----
    // Mouse
    slider.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);

    // Touch
    slider.addEventListener("touchstart", onTouchStart, { passive: true });
    slider.addEventListener("touchmove", onTouchMove, { passive: false });
    slider.addEventListener("touchend", onTouchEnd);
  });
});